import { render, staticRenderFns } from "./DbMonitor.vue?vue&type=template&id=569663de&"
import script from "./DbMonitor.vue?vue&type=script&lang=js&"
export * from "./DbMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('569663de')) {
      api.createRecord('569663de', component.options)
    } else {
      api.reload('569663de', component.options)
    }
    module.hot.accept("./DbMonitor.vue?vue&type=template&id=569663de&", function () {
      api.rerender('569663de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/DbMonitor.vue"
export default component.exports